import { useCallback } from 'react';
import { useCompStyleElementObserver } from '@wix/thunderbolt-elements/providers/useCompStyleElementObserver';
import {
  dataSelectors,
  updateDropdownDomStyles,
} from '../components/MenuItem/updateDropdownDomStyles';

export const useUpdateDropdownPosition = (
  id: string,
  shownDropdownId: string | undefined,
) => {
  const updateDropdownPosition = useCallback(() => {
    const itemEl = document
      .getElementById(id)
      ?.querySelector(`[${dataSelectors.open}]`);

    if (itemEl) {
      updateDropdownDomStyles(itemEl as HTMLElement, false);
    }
  }, [id]);

  useCompStyleElementObserver({
    compIds: [id, shownDropdownId].filter(Boolean) as Array<string>,
    shouldObserve: !!shownDropdownId,
    callback: updateDropdownPosition,
  });
};
